<script lang="ts">
  interface Props {
    color?: string;
    bottom?: number;
    class?: string;
    children?: import("svelte").Snippet;
  }

  let { color, bottom = 0, class: classes = "", children }: Props = $props();
  let colorVar = $derived(color ? `var(--${color})` : null);
</script>

<small
  aria-hidden="true"
  style="--_color: {colorVar ? colorVar : 'currentcolor'}; --_bottom: {bottom}px;"
  class="tick-y-top border-b-1px border-b-solid absolute left-[calc(-1*var(--tick-y-left))] w-[calc(var(--tick-y-left))] whitespace-nowrap z-4 {classes}"
>
  {@render children?.()}
</small>

<style lang="postcss">
  small {
    /* position need -2px for some reason to be correct */
    bottom: calc(var(--_bottom) - 2px);
    border-color: var(--_color);
  }
</style>
